var map = {
	"./translations.ar.json": 9551,
	"./translations.de.json": 9063,
	"./translations.en.json": 1791,
	"./translations.es.json": 7256,
	"./translations.fa.json": 4713,
	"./translations.fr.json": 6044,
	"./translations.ht.json": 2792,
	"./translations.kea.json": 1915,
	"./translations.ko.json": 1482,
	"./translations.pa.json": 7455,
	"./translations.pt.json": 3600,
	"./translations.ru.json": 7785,
	"./translations.sl.json": 6723,
	"./translations.so.json": 1474,
	"./translations.vi.json": 2097,
	"./translations.zh.json": 9586,
	"./translations.zh_TW.json": 6557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 123;